// extracted by mini-css-extract-plugin
export default {"menuSidebar":"Header_menuSidebar__3Znw3","menuOpened":"Header_menuOpened__XMKPP"};